export const colorPalette = {
  primary: "#3F8310",
  primaryLight: "#EBF7DF",
  secondary: "#63CF19",
  tertiary: "#EBF7DF",
  alto: "#D2D2D2",
  mine_shaftapprox: "#2E2E2E",
};
